module.exports = __webpack_public_path__ + "img/ClaimCoupon.6393c005.png";